import initialObjects from "../../app-config/initial-objects.cg3";
import SampleDemo from "./test-load-sample";
import FileDropper from "./file-drop.js";
import cabri from "./cabri-app";
import {tracker} from "./analytics";
import {registerAPI} from "../../deploy/desktop/desktop-web";

async function fileLoad (sourceUrl) {
    let parser;
    if (sourceUrl) {
        console.log("Loading CG3 file from " + sourceUrl);
        tracker().trackEvent("files", "load", [sourceUrl], []);
        parser = new Parser(sourceUrl);
        console.log("Setting ",
            window.document.title = "Cabri 3D - " + extractTitle(sourceUrl));
    }
    else {
        console.log(`Loading default CG3 file.`);
        tracker().trackEvent("files", "load-default", [], []);
        parser = new Parser(initialObjects);
    }

    if (window.cabri)
        window.cabri.document = await parser.parse();
    window.cabri.objects = parser.objects;
    console.log(`Promise to load CG3 file ${initialObjects}.`,
        window.cabri.document);
}

function extractTitle (url) {
    if (window.titleOfFile) {
        url = window.titleOfFile;
        window.titleOfFile = null;
    }
    const defaultFileName = "cg3-file";
    if (typeof (url) !== "string" || url.length == 0) return defaultFileName;
    let p = url.indexOf("?");
    if (p > 0) url = url.substring(0, p);
    p = url.lastIndexOf("/") + 1;
    if (p >= 0 && p < url.length) return unescape(url.substring(p));
    else return defaultFileName;
}

async function initFile () {
    if (window.bridge && window.bridge.isElectronApp) {     // ----- desktop app
        registerAPI();
        if (window.bridge.fileToLoad)
            bridge.fileRead(window.bridge.fileToLoad);
        else                                                // initial file
            fileLoad();
    }
    else {                                                  // ------- web app
        const urlParams = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                urlParams[key] = value;
            });
        const urlToLoad = window.urlToLoad ||
            urlParams["cg3"] || urlParams["src"] || null;
            // automatic interpretation of "false" if undefined and true otherwise
            // and || returns one of its operands (the first non-false).
        if (urlToLoad)
            await FileLoader.fileLoad(urlToLoad);
        else
            await SampleDemo.testIt();

        // load per drop
        new FileDropper(cabri.canvas);
    }

}

const FileLoader = {fileLoad: fileLoad, initFile: initFile};
window.FileLoader = FileLoader;
export default FileLoader;